import React from 'react';
import { Container } from 'react-bootstrap';
import Hero from '../components/Hero';
import InfoPanels from '../components/InfoPanel';
import Sponsors from '../components/Sponsors';
import { Helmet } from 'react-helmet-async';

const Home: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Ashridge Park FC | Grassroots Football Club in Wokingham</title>
        <meta name="description" content="Welcome to Ashridge Park FC, a charter standard community football club in Wokingham, Berkshire, offering youth and adult football for all ages." />
      </Helmet>
      <Hero />
      {/* <Container className="p-3 my-4"> */}
      <Container fluid className="px-4 px-md-5 my-4">
        <InfoPanels />
      </Container>
      <Sponsors />
    </>
  );
};

export default Home;